let vendorTypes = ['alaga', 'asoebi', 'asoebibella', 'attire', 'bead', 'beautiful', 'bridal dress', 'bridal gown', 'bridal stylist',
  'brides outfit', 'brides robe', 'brides shoes', 'bridesmaid dresses', 'bridesmaids', 'bridesmaids hair', 'bridesmaids makeup',
  'caterer', 'cinematographer', 'clutch', 'cocktails', 'coordination', 'coordinator', 'couple', 'creative director', 'decorator',
  'design brand', 'dessert', 'desserts', 'dress designer', 'drinks', 'earrings', 'eru iyawo', 'fascinator', 'fashion illustrator',
  'florals', 'florist', 'flowers', 'food', 'gown', 'grooms outfit', 'grooms shoes', 'grooms suit', 'grooms tuxedo', 'groomsmen suit',
  'groomtobe', 'hair piece', 'hairstylist', 'headpiece', 'henna', 'hotel', 'ig', 'instagram', 'jewellery', 'kente', 'lashes', 'live band',
  'lovely', 'makeup artist', 'mc', 'model', 'models', 'muse', 'music', 'nails', 'outfits', 'photobooth', 'planners', 'ring', 'robe', 'see',
  'shoes', 'special effect', 'spotted', 'stationery', 'studio', 'suit', 'suits', 'thank you', 'tiara', 'to', 'turban', 'us', 'venue',
  'wedding coordinator', 'wedding dress']
let countries = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda',
  'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil',
  'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands',
  'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus',
  'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia',
  'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia',
  'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau',
  'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel',
  'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho',
  'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali',
  'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia',
  'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan',
  'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania',
  'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia',
  'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand',
  "Timor L'Este", 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine',
  'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe']

let nigeriaPriceRanges = [
  '25,000 and below',
  '25,000 - 50,000',
  '50,000 - 100,000',
  '100,000 - 250,000',
  '250,000 - 400,000',
  '400,000 - 600,000',
  '600,000 - 1,000,000',
  '1,000,000 - 2,000,000',
  '2,000,000 - 4,000,000',
  '4,000,000 and above'
]

let usPriceRanges = [
  '1,000 and below',
  '1,000 - 5,000',
  '5,000 - 15,000',
  '15,000 - 30,000',
  '30,000 - 50,000',
  '50,000 - 100,000',
  '100,000 - 250,000',
  '250,000 - 500,000',
  '500,000 - 1,000,000',
  '1,000,000 and above'
]
export {
  vendorTypes,
  countries,
  nigeriaPriceRanges,
  usPriceRanges
}



// WEBPACK FOOTER //
// ./src/constants.js